/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlogPostPaginateResponse } from '../../models/blog-post-paginate-response';

export interface GetBlogPostIndex$Params {

/**
 * Pagination offset
 */
  page?: number;

/**
 * Pagination limit
 */
  limit?: number;

/**
 * Pagination order field ascending
 */
  orderAsc?: 'id' | 'createdAt' | 'updatedAt';

/**
 * Pagination order field descending
 */
  orderDesc?: 'id' | 'createdAt' | 'updatedAt';

/**
 * Filter blogPost id
 */
  id?: number;
}

export function getBlogPostIndex(http: HttpClient, rootUrl: string, params?: GetBlogPostIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<BlogPostPaginateResponse>> {
  const rb = new RequestBuilder(rootUrl, getBlogPostIndex.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('orderAsc', params.orderAsc, {});
    rb.query('orderDesc', params.orderDesc, {});
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlogPostPaginateResponse>;
    })
  );
}

getBlogPostIndex.PATH = '/v1/blog-post';
